import React, { useEffect } from "react";
import Icon from "../Icon";
import cx from "classnames";

import alertIcon from "./images/alert.svg";
import errorIcon from "./images/fail.svg";
import successIcon from "./images/success.svg";

const typeMap = {
  success: successIcon,
  error: errorIcon,
  warning: alertIcon
};

export default function Notice({
  time = 3000,
  type = "warning",
  content,
  onEnd
}) {
  useEffect(() => {
    setTimeout(onEnd, time);
  }, []);

  const icon = typeMap[type];

  const cls = cx("notice", type);

  return (
    <div className={cls}>
      <Icon link={icon} className="notice-icon" />
      {content}
    </div>
  );
}
